import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-slot-detail',
  templateUrl: './slot-detail.component.html',
  styleUrls: ['./slot-detail.component.scss']
})
export class SlotDetailComponent implements OnInit {
  @Input()
  data: {
    value: any,
    higlight: boolean,
    type: string,
    bookedhiglight: boolean,
    show: boolean
  }

  @Input()
  hideAllGreen: boolean;
  constructor() { }

  ngOnInit(): void {
  }

}
